import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { ColumnForSelection } from 'src/app/shared/import/column-for-selection';
import { BaseImportStepComponent } from '../base-import-step.component';
import { ColumnScrollService } from '../column-scroll.service';
import { ProjectService } from 'src/app/shared/project/project.service';

@Component({
    template: '' // Abstract component, template will be provided by extending classes
})
export abstract class BaseColumnSelectComponent extends BaseImportStepComponent implements AfterViewInit {
    columns: ColumnForSelection[];
    selectedColumn: ColumnForSelection;

    @ViewChild('tableContainer', { static: false }) tableContainer: ElementRef;

    constructor(protected projectService: ProjectService, protected columnScrollService?: ColumnScrollService) {
        super(projectService);
    }

    ngAfterViewInit(): void {
        this.scrollToSelectedColumnIfReady();
    }

    public override setActive(val: boolean): void {
        const wasActive = this.isActive();
        super.setActive(val);
        
        // If component just became active and we have data, scroll
        if (val && !wasActive && this.columns) {
            // Use setTimeout to ensure the DOM is updated after setActive
            setTimeout(() => {
                this.scrollToSelectedColumnIfReady();
            }, 0);
        }
    }

    protected scrollToSelectedColumnIfReady(): void {
        // Only scroll if the component is active and we have the scroll service
        if (!this.isActive() || !this.columnScrollService) {
            return;
        }
        
        if (this.tableContainer && this.columns) {
            this.columnScrollService.scrollToSelectedColumn(this.tableContainer, this.columns);
        }
    }

    public selectColumn(column: ColumnForSelection): void {
        if (!column || !column.isEligible) {
            return;
        }
        for (var i = 0; i < this.columns.length; ++i) {
            this.columns[i].isSelected = false;
        }
        column.isSelected = true;
        this.selectedColumn = column;
    }

    public displayRoughNum(num: number): string {
        if(num < 100) {
            return `${num} values`;
        }
        if(num < 200) {
            return `> 100`;
        }
        if(num < 400) {
            return `> 200`;
        }
        if(num <= 1000) {
            return `> 400`;
        }
        return `> 1000`;
    }
}
